import { render, staticRenderFns } from "./im-search-tab.vue?vue&type=template&id=6cb3a3ea"
import script from "./im-search-tab.vue?vue&type=script&lang=js"
export * from "./im-search-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb3a3ea')) {
      api.createRecord('6cb3a3ea', component.options)
    } else {
      api.reload('6cb3a3ea', component.options)
    }
    module.hot.accept("./im-search-tab.vue?vue&type=template&id=6cb3a3ea", function () {
      api.rerender('6cb3a3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/im-search-tab.vue"
export default component.exports